import React from "react";

import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {Link} from "react-router-dom";
import {apollo_useStyles, menuNameMaster, platformPathMaster} from "./Apollo_styles";
import {ApolloContext} from "./Apollo_Context";
import {
  home_path,
  accountdetailapollo_path,
  adclienticonsapollo_path,
  accountgroups_path,
  isummary_path,
  info_path,
  heraaudiences_path,
  herasetpoints_path,
  users_path,
  customsegmentposeidon_path,
  affinitycategorylistposeidon_path,
  userlistposeidon_path,
  geosegmentallposeidon_path,
  geosegmentposeidon_path,
  budget_path,
  adgroups_path,
  advertisements_path,
  segmentdetailposeidon_path,
  geosegmenteditposeidon_path,
  crassets_path, accountdetail_path, accountgroupdetail_path,
  review_csv_path,
} from "./Apollo_links";

export type BreadcrumbsData = {
  categoryId: number;         // ページのカテゴリID
  breadId: number;            // パンくずID
  queries: string[];          // クエリパラメータ群 (先頭からlist.indexの値に対応)
  menu: menuInfo | null,      // 選択中のメニュー(プラットフォーム)情報
  campaign: info | null,      // 選択中キャンペーン情報
  adgroup: info | null,       // 選択中の広告グループ情報
  advertisement: info | null, // 選択中の広告情報
  asset: info | null,         // 選択中の広告アセット情報
}

type menuInfo = {
  id: number,           // メニューID 1:パフォーマンス広告(Zeus) 2:メール広告(MS) 
  accountId: string,    // プラットフォームアカウントID
  accountName: string,  // プラットフォームアカウント名
}

type info = {
  id: string,
  name: string,
}

type BreadcrumbsMaster = {
  categoryId: number,
  description: string,
  pages: page[],
}

type page = {
  breadId: number,
  description: string,
  list: Breadcrumb[],
}

type Breadcrumb = {
  index: number,
  path: string,
  title: string,
};

// パンくずコンポーネント
export function ApolloBreadcrumbs2(Props: { data: BreadcrumbsData }) {
  const classes = apollo_useStyles();
  const {data} = Props;
  const breadcrumbs = GetBreadcrumbs(data);

  return (
    <Breadcrumbs separator="›" aria-label="breadcrumb">
      {breadcrumbs?.map((bread: Breadcrumb) => (
        <Link color="inherit" to={bread.path} key={bread.index}
              className={classes.breadlink}
        >
          {
            bread.title
          }
        </Link>
      ))}
    </Breadcrumbs>
  );
}

// パンくずリスト呼び出し ※パスの直書き ダメ、ゼッタイ！
function GetBreadcrumbs(data: BreadcrumbsData): Breadcrumb[] {
  const {state} = React.useContext(ApolloContext);
  const accountgroup = {
    id: state.current.accountGroupId,
    name: state.current.accountGroupName,
  };
  const account = {
    id: state.current.accountId,
    name: state.current.accountName,
  };
  const menu = {
    path: data.menu ? platformPathMaster[data.menu?.id] : "",
    name: data.menu ? menuNameMaster[data.menu.id] : "",
    accountId: data.menu ? data.menu?.accountId : 0,
    accountName: data.menu ? data.menu?.accountName : "",
  };
  const campaign = {
    id: data.campaign ? data.campaign?.id : 0,
    name: data.campaign ? data.campaign?.name : "",
  }
  const adgroup = {
    id: data.adgroup ? data.adgroup?.id : 0,
    name: data.adgroup ? data.adgroup?.name : "",
  }
  // const advertisement = {
  //   id: data.advertisement ? data.advertisement?.id : 0,
  //   name: data.advertisement ? data.advertisement?.name : "",
  // }
  // const asset = {
  //   id: data.asset ? data.asset?.id : 0,
  //   name: data.asset ? data.asset?.name : "",
  // }

  const queries: string[] = new Array(10).fill("");

  // パンくずにクエリパラメータを渡す
  data.queries?.map((query, key) => {
    queries[key + 1] = query;
  });

  const currentPath = "#";
  const homePath: Breadcrumb = {index: 1, path: home_path , title: "ホーム"};

  const accountPath: Breadcrumb = {
    index: 2,
    path: accountdetailapollo_path + accountgroup.id + "/" + account.id + queries[2],
    title: account.name, // 選択中の広告主アカウント名を表示
  };
  const menuPath: Breadcrumb = {
    index: 3,
    path: accountdetail_path + "/" + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[3],
    title: menu.name, // 選択中のPFメニュー名を表示
  };

  const users: BreadcrumbsMaster = {
    categoryId: 2,
    description: "ユーザー管理",
    pages: [
      {
        breadId: 1,
        description: "ユーザーロール一覧",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "ユーザーロール一覧"},
        ]
      },
      {
        breadId: 2,
        description: "ユーザー作成",
        list: [
          homePath,
          {index: 2, path: users_path + queries[2], title: "ユーザーロール一覧"},
          {index: 3, path: currentPath, title: "ユーザー作成"},
        ]
      },
      {
        breadId: 3,
        description: "ユーザー詳細",
        list: [
          homePath,
          {index: 2, path: users_path + queries[2], title: "ユーザーロール一覧"},
          {index: 3, path: currentPath, title: "ユーザー詳細："},
        ]
      },
      {
        breadId: 4,
        description: "ユーザー編集",
        list: [
          homePath,
          {index: 2, path: users_path + queries[2], title: "ユーザーロール一覧"},
          {index: 3, path: currentPath, title: "ユーザー編集："},
        ]
      },
    ]
  };

  const notifies: BreadcrumbsMaster = {
    categoryId: 3,
    description: "通知メッセージ管理",
    pages: [
      {
        breadId: 1,
        description: "通知メッセージ一覧",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "通知メッセージ一覧"},
        ]
      },
      {
        breadId: 2,
        description: "通知メッセージ作成",
        list: [
          homePath,
          {index: 2, path: info_path + queries[2], title: "通知メッセージ一覧"},
          {index: 3, path: currentPath, title: "通知メッセージー作成"},
        ]
      },
      {
        breadId: 3,
        description: "通知メッセージ詳細",
        list: [
          homePath,
          {index: 2, path: info_path + queries[2], title: "通知メッセージ一覧"},
          {index: 3, path: currentPath, title: "通知メッセージ詳細："},
        ]
      },
      {
        breadId: 4,
        description: "通知メッセージ編集",
        list: [
          homePath,
          {index: 2, path: info_path + queries[2], title: "通知メッセージ一覧"},
          {index: 3, path: currentPath, title: "通知メッセージ編集："},
        ]
      },
    ]
  };

  const masters: BreadcrumbsMaster = {
    categoryId: 4,
    description: "マスター管理",
    pages: [
      {
        breadId: 1,
        description: "マスター管理",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "マスター管理"},
        ]
      },
    ]
  };

  const billings: BreadcrumbsMaster = {
    categoryId: 5,
    description: "確定請求金額管理",
    pages: [
      {
        breadId: 1,
        description: "確定請求金額",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "確定請求金額"},
        ]
      },
    ]
  };

  const budgets: BreadcrumbsMaster = {
    categoryId: 6,
    description: "予算管理",
    pages: [
      {
        breadId: 1,
        description: "予算管理一覧",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "予算管理一覧"},
        ]
      },
    ]
  };

  const logs: BreadcrumbsMaster = {
    categoryId: 7,
    description: "操作ログ管理",
    pages: [
      {
        breadId: 1,
        description: "操作ログ確認",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "操作ログ確認"},
        ]
      },
    ]
  };

  const segments = {
    categoryId: 8,
    description: "セグメント管理(Poseidon関連)",
    pages: [
      // NOTE: 現状、breadId は「id検索」ではなく配列インデックスとして参照されているため、
      //       削除や順序変更すると以降の画面でパンくず構造がずれる可能性がある。
      //       そのため、該当画面（breadId:1〜3）は削除せず空定義として残す。
      {
        breadId: 1,
        description: "",
        list: []
      },
      {
        breadId: 2,
        description: "",
        list: []
      },
      {
        breadId: 3,
        description: "",
        list: []
      },
      {
        breadId: 4,
        description: "カスタムセグメント一覧",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "カスタムセグメント一覧"},
        ]
      },
      {
        breadId: 5,
        description: "カスタムセグメント詳細",
        list: [
          homePath,
          {index: 2, path: customsegmentposeidon_path, title: "カスタムセグメント一覧"},
          {index: 3, path: segmentdetailposeidon_path + queries[1] + queries[2], title: "カスタムセグメント詳細"},
        ]
      },
      {
        breadId: 6,
        description: "アフィニティカテゴリ一覧",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "アフィニティカテゴリ一覧"},
        ]
      },
      {
        breadId: 7,
        description: "アフィニティカテゴリ作成",
        list: [
          homePath,
          {index: 2, path: affinitycategorylistposeidon_path, title: "アフィニティカテゴリ一覧"},
          {index: 3, path: currentPath, title: "アフィニティカテゴリ作成"},
        ]
      },
      {
        breadId: 8,
        description: "アフィニティカテゴリ編集",
        list: [
          homePath,
          {index: 2, path: affinitycategorylistposeidon_path, title: "アフィニティカテゴリ一覧"},
          {index: 3, path: currentPath, title: "アフィニティカテゴリ編集"},
        ]
      },
      {
        breadId: 9,
        description: "ユーザーリスト一覧",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "ユーザーリスト一覧"},
        ]
      },
      {
        breadId: 10,
        description: "ユーザーリスト作成",
        list: [
          homePath,
          {index: 2, path: userlistposeidon_path, title: "ユーザーリスト一覧"},
          {index: 3, path: currentPath, title: "ユーザーリスト作成"},
        ]
      },
      {
        breadId: 11,
        description: "ユーザーリスト編集",
        list: [
          homePath,
          {index: 2, path: userlistposeidon_path, title: "ユーザーリスト一覧"},
          {index: 3, path: currentPath, title: "ユーザーリスト編集"},
        ]
      },
      {
        breadId: 12,
        description: "ジオセグメント一覧(ALL)",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "ジオセグメント一覧(ALL)"},
        ]
      },
      {
        breadId: 13,
        description: "ジオセグメント作成",
        list: [
          homePath,
          {index: 2, path: geosegmentallposeidon_path, title: "ジオセグメント一覧(ALL)"},
          {index: 3, path: currentPath, title: "ジオセグメント作成"},
        ]
      },
      {
        breadId: 14,
        description: "ジオセグメント編集(ALL)",
        list: [
          homePath,
          {index: 2, path: geosegmentallposeidon_path, title: "ジオセグメント一覧(ALL)"},
          {index: 3, path: geosegmenteditposeidon_path + queries[1] + queries[2], title: "ジオセグメント編集"},
        ]
      },
      {
        breadId: 15,
        description: "ジオセグメント一覧",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "ジオセグメント一覧"},
        ]
      },
      {
        breadId: 16,
        description: "ジオセグメント編集",
        list: [
          homePath,
          {index: 2, path: geosegmentposeidon_path, title: "ジオセグメント一覧"},
          {index: 3, path: geosegmenteditposeidon_path + queries[1] + queries[2], title: "ジオセグメント編集"},
        ]
      },
    ]
  }

  const accountgroups: BreadcrumbsMaster = {
    categoryId: 9,
    description: "アカウントグループ管理",
    pages: [
      {
        breadId: 1,
        description: "アカウントグループ一覧",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "アカウントグループ一覧"},
        ]
      },
      {
        breadId: 2,
        description: "アカウントグループ作成",
        list: [
          homePath,
          {index: 2, path: accountgroups_path + queries[2], title: "アカウントグループ一覧"},
          {index: 3, path: currentPath, title: "アカウントグループ作成"},
        ]
      },
      {
        breadId: 3,
        description: "アカウントグループ詳細",
        list: [
          homePath,
          {index: 2, path: accountgroups_path + queries[2], title: "アカウントグループ一覧"},
          {index: 3, path: currentPath, title: "アカウントグループ詳細"},
        ]
      },
      {
        breadId: 4,
        description: "アカウントグループ編集",
        list: [
          homePath,
          {index: 2, path: accountgroups_path + queries[2], title: "アカウントグループ一覧"},
          {index: 3, path: currentPath, title: "アカウントグループ編集"},
        ]
      },
    ]
  };

  const accounts: BreadcrumbsMaster = {
    categoryId: 10,
    description: "広告主アカウント管理",
    pages: [
      {
        breadId: 1,
        description: "広告主アカウント作成(静的表示)",
        list: [
          homePath,
          {index: 2, path: accountgroups_path + queries[2], title: "アカウントグループ一覧"},
          {index: 3, path: accountgroupdetail_path + accountgroup.id + queries[3], title: accountgroup.name}, // 選択中のアカウントグループ名を表示
          {index: 4, path: currentPath, title: "広告主アカウント作成"},
        ]
      },
      {
        breadId: 2,
        description: "広告主アカウント詳細(静的表示)",
        list: [
          homePath,
          {index: 2, path: accountgroups_path + queries[2], title: "アカウントグループ一覧"},
          {index: 3, path: accountgroupdetail_path + accountgroup.id + queries[3], title: accountgroup.name}, // 選択中のアカウントグループ名を表示
          {index: 4, path: currentPath, title: "広告主アカウント詳細"},
        ]
      },
      {
        breadId: 3,
        description: "広告主アカウント詳細(広告グループ一覧から遷移)",
        list: [
          homePath,
          {index: 2, path: accountgroups_path + queries[2], title: "アカウントグループ一覧"},
          {index: 3, path: accountgroupdetail_path + accountgroup.id + queries[3], title: accountgroup.name}, // 選択中のアカウントグループ名を表示
          {index: 4, path: currentPath, title: "広告主アカウント詳細"},
        ]
      },
      {
        breadId: 4,
        description: "広告主アカウント詳細(キャンペーン一覧から遷移)",
        list: [
          homePath,
          {index: 2, path: isummary_path + queries[2], title: "キャンペーン一覧"},
          {index: 3, path: currentPath, title: "広告主アカウント詳細"},
        ]
      },
      {
        breadId: 5,
        description: "広告主アカウント編集(静的表示)",
        list: [
          homePath,
          {index: 2, path: accountgroups_path + queries[2], title: "アカウントグループ一覧"},
          {index: 3, path: accountgroupdetail_path + accountgroup.id + queries[3], title: accountgroup.name},
          {index: 4, path: currentPath, title: "広告主アカウント編集"},
        ]
      },
    ]
  };

  const platformAccounts: BreadcrumbsMaster = {
    categoryId: 11,
    description: "プラットフォームアカウント管理",
    pages: [
      {
        breadId: 1,
        description: "プラットフォームアカウント詳細(静的表示)",
        list: [
          homePath,
          {index: 2, path: accountgroups_path + queries[2], title: "アカウントグループ一覧"},
          {index: 3, path: accountgroupdetail_path + accountgroup.id + queries[3], title: accountgroup.name}, // 選択中のアカウントグループ名を表示
          {
            index: 4,
            path: accountdetailapollo_path + accountgroup.id + "/" + account.id + queries[4],
            title: account.name
          }, // 選択中の広告主アカウント名を表示
          {index: 5, path: currentPath, title: menu.name + "アカウント詳細"},
        ]
      },
      {
        breadId: 2,
        description: "プラットフォームアカウント詳細(広告グループ一覧経由)",
        list: [
          homePath,
          {index: 2, path: accountgroups_path + queries[2], title: "アカウントグループ一覧"},
          {index: 2, path: accountgroups_path + queries[2], title: accountgroup.name}, // 選択中のアカウントグループ名を表示
          {
            index: 3,
            path: accountdetailapollo_path + accountgroup.id + "/" + account.id + queries[3],
            title: account.name
          }, // 選択中の広告主アカウント名を表示
          {index: 4, path: currentPath, title: menu.name + "アカウント詳細"},
        ]
      },
      {
        breadId: 3,
        description: "プラットフォームアカウント詳細(キャンペーン一覧経由)",
        list: [
          homePath,
          {index: 2, path: isummary_path + queries[2], title: "キャンペーン一覧"},
          {
            index: 3,
            path: accountdetailapollo_path + accountgroup.id + "/" + account.id + queries[3],
            title: account.name
          }, // 選択中の広告主アカウント名を表示
          {index: 4, path: currentPath, title: menu.name + "アカウント詳細"},
        ]
      },
      {
        breadId: 4,
        description: "プラットフォームアカウント詳細(予算管理一覧経由)",
        list: [
          homePath,
          {index: 2, path: budget_path + queries[2], title: "予算管理一覧"},
          {
            index: 3,
            path: accountdetailapollo_path + accountgroup.id + "/" + account.id + queries[3],
            title: account.name
          }, // 選択中の広告主アカウント名を表示
          {index: 4, path: currentPath, title: menu.name + "アカウント詳細"},
        ]
      },
    ]
  };

  const deletedAdvertisements: BreadcrumbsMaster = {
    categoryId: 14,
    description: "広告管理",
    pages: []
  };

  const draftCsv: BreadcrumbsMaster = {
    categoryId: 15,
    description: "一括処理アップロード(CSV入稿)",
    pages: [
      {
        breadId: 1,
        description: "一括処理アップロード",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: currentPath, title: "一括処理アップロード"},
        ]
      },
    ]
  };

  const assets: BreadcrumbsMaster = {
    categoryId: 16,
    description: "広告アセット管理",
    pages: [
      {
        breadId: 1,
        description: "広告アセット一覧",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: currentPath, title: "広告アセット一覧"},
        ]
      },
      {
        breadId: 2,
        description: "広告アセット作成",
        list: [
          homePath,
          accountPath,
          menuPath,
          {
            index: 4,
            path: crassets_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[4],
            title: "広告アセット一覧"
          },
          {index: 5, path: currentPath, title: "広告アセット作成"},
        ]
      },
      {
        breadId: 3,
        description: "広告アセット詳細",
        list: [
          homePath,
          accountPath,
          menuPath,
          {
            index: 4,
            path: crassets_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[4],
            title: "広告アセット一覧"
          },
          {index: 5, path: currentPath, title: "広告アセット詳細"},
        ]
      },
    ]
  };

  const trackers: BreadcrumbsMaster = {
    categoryId: 17,
    description: "トラッキング管理(Hera関連)",
    pages: [
      {
        breadId: 1,
        description: "イベント一覧",
        list: [
          homePath,
          accountPath,
          {index: 3, path: currentPath, title: "イベント一覧"},
        ]
      },
      {
        breadId: 2,
        description: "オーディエンス一覧",
        list: [
          homePath,
          accountPath,
          {index: 3, path: currentPath, title: "オーディエンス一覧"},
        ]
      },
      {
        breadId: 3,
        description: "オーディエンス作成",
        list: [
          homePath,
          accountPath,
          {index: 3, path: heraaudiences_path + queries[3], title: "オーディエンス一覧"},
          {index: 4, path: currentPath, title: "オーディエンス作成"},
        ]
      },
      {
        breadId: 4,
        description: "オーディエンス詳細",
        list: [
          homePath,
          accountPath,
          {index: 3, path: heraaudiences_path + queries[3], title: "オーディエンス一覧"},
          {index: 4, path: currentPath, title: "オーディエンス詳細"},
        ]
      },
      {
        breadId: 5,
        description: "測定ポイント一覧",
        list: [
          homePath,
          accountPath,
          {index: 3, path: currentPath, title: "測定ポイント一覧"},
        ]
      },
      {
        breadId: 6,
        description: "測定ポイント作成",
        list: [
          homePath,
          accountPath,
          {index: 3, path: herasetpoints_path + queries[3], title: "測定ポイント一覧"},
          {index: 4, path: currentPath, title: "測定ポイント作成"},
        ]
      },
    ]
  };

  const reports: BreadcrumbsMaster = {
    categoryId: 18,
    description: "レポート管理",
    pages: [
      {
        breadId: 1,
        description: "レポート管理",
        list: [
          homePath,
          accountPath,
          {index: 3, path: currentPath, title: "レポート管理"},
        ]
      },
    ]
  };

  const adAssetBatch: BreadcrumbsMaster = {
    categoryId: 19,
    description: "広告アセット一括アップロード(CSV,画像ZIP入稿)",
    pages: [
      {
        breadId: 1,
        description: "広告アセット一括アップロード",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: currentPath, title: "広告アセット一括アップロード"},
        ]
      },
    ]
  };

  const adClientIcon: BreadcrumbsMaster = {
    categoryId: 20,
    description: "広告主アイコン管理",
    pages: [
      {
        breadId: 1,
        description: "広告主アイコン一覧",
        list: [
          homePath,
          accountPath,
          {index: 3, path: currentPath, title: "広告主アイコン一覧"},
        ]
      },
      {
        breadId: 2,
        description: "広告主アイコン作成",
        list: [
          homePath,
          accountPath,
          {index: 3, path: adclienticonsapollo_path + accountgroup.id + "/" + account.id + queries[3], title: "広告主アイコン一覧"},
          {index: 4, path: currentPath, title: "広告主アイコン作成"},
        ]
      },
      {
        breadId: 3,
        description: "広告主アイコン審査一覧",
        list: [
          homePath,
          {index: 3, path: currentPath, title: "広告主アイコン審査一覧"},
        ]
      },
    ]
  };

  const manuals: BreadcrumbsMaster = {
    categoryId: 21,
    description: "マニュアル管理",
    pages: [
      {
        breadId: 1,
        description: "マニュアル管理",
        list: [
          homePath,
          {index: 2, path: currentPath, title: "マニュアル管理"},
        ]
      },
    ]
  };

    const home: BreadcrumbsMaster = {
    categoryId: 22,
    description: "ホーム",
    pages: [
      {
        breadId: 1,
        description: "ホーム",
        list: [
          homePath,
        ]
      },
    ]
  };
  const campaigns: BreadcrumbsMaster = {
    categoryId: 23,
    description: "キャンペーン管理",
    pages: [
      {
        breadId: 1,
        description: "キャンペーン一覧",
        list: [
          homePath,
          accountPath,
          {index: 3, path: currentPath, title: "キャンペーン一覧"},
        ]
      },
      {
        breadId: 2,
        description: "キャンペーン作成(静的表示)",
        list: [
          homePath,
          accountPath,
          {index: 3, path: isummary_path + queries[3], title: "キャンペーン一覧"},
          {index: 4, path: currentPath, title: menu.name + "キャンペーン作成"},
        ]
      },
    ]
  };

  const adgroups: BreadcrumbsMaster = {
    categoryId: 24,
    description: "広告グループ管理",
    pages: [
      {
        breadId: 1,
        description: "広告グループ一覧(静的表示)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: isummary_path + queries[4], title: "キャンペーン一覧"},
          {index: 5, path: currentPath, title: "広告グループ一覧"},
        ]
      },
      {
        breadId: 2,
        description: "広告グループ作成(静的表示)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: isummary_path + queries[4], title: "キャンペーン一覧"},
          {
            index: 5,
            path: adgroups_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[5],
            title: "広告グループ一覧"
          },
          {index: 6, path: currentPath, title: "広告グループ作成"},
        ]
      },
      {
        breadId: 3,
        description: "広告グループ一覧(サイドメニューから遷移)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: currentPath, title: "広告グループ一覧"},
        ]
      },
      {
        breadId: 4,
        description: "広告グループ作成(サイドメニュー経由)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {
            index: 4,
            path: adgroups_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[4],
            title: "広告グループ一覧"
          },
          {index: 5, path: currentPath, title: "広告グループ作成"},
        ]
      },
      {
        breadId: 5,
        description: "広告グループ一覧(キャンペーン一覧から遷移)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: isummary_path + queries[4], title: campaign.name}, // 選択中のキャンペーン名を表示
          {index: 5, path: currentPath, title: "広告グループ一覧"},
        ]
      },
      {
        breadId: 6,
        description: "広告グループ作成(キャンペーン一覧・作成経由)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: isummary_path + queries[4], title: campaign.name},  // 選択中のキャンペーン名を表示
          {
            index: 5,
            path: adgroups_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[5],
            title: "広告グループ一覧"
          },
          {index: 6, path: currentPath, title: "広告グループ作成"},
        ]
      },
    ]
  };

  const tags: BreadcrumbsMaster = {
    categoryId: 26,
    description: "広告アセット管理",
    pages: [
      {
        breadId: 1,
        description: "広告アセット一覧",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: currentPath, title: "広告アセット一覧"},
        ]
      },
      {
        breadId: 2,
        description: "広告アセット作成(タグアセット)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {
            index: 4,
            path: crassets_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[4],
            title: "広告アセット一覧"
          },
          {index: 5, path: currentPath, title: "広告アセット作成(タグアセット)"},
        ]
      },
    ]
  };

  const advertisements: BreadcrumbsMaster = {
    categoryId: 25,
    description: "広告管理",
    pages: [
      {
        breadId: 1,
        description: "広告一覧(静的表示)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: isummary_path + queries[4], title: "キャンペーン一覧"},
          {
            index: 5,
            path: adgroups_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[5],
            title: "広告グループ一覧"
          },
          {index: 6, path: currentPath, title: "広告一覧"},
        ]
      },
      {
        breadId: 2,
        description: "広告作成(静的表示)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: isummary_path + queries[4], title: "キャンペーン一覧"},
          {
            index: 5,
            path: adgroups_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[5],
            title: "広告グループ一覧"
          },
          {
            index: 6,
            path: advertisements_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[6],
            title: "広告一覧"
          },
          {index: 7, path: currentPath, title: "広告作成"},
        ]
      },
      {
        breadId: 3,
        description: "広告一覧(サイドメニュー経由)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: currentPath, title: "広告一覧"},
        ]
      },
      {
        breadId: 4,
        description: "広告作成(サイドメニュー経由)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {
            index: 4,
            path: advertisements_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[4],
            title: "広告一覧"
          },
          {index: 5, path: currentPath, title: "広告作成"},
        ]
      },
      {
        breadId: 5,
        description: "広告一覧(広告グループ一覧から遷移)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {
            index: 4,
            path: adgroups_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[4],
            title: adgroup.name
          }, // 選択中の広告グループ名を表示
          {index: 5, path: currentPath, title: "広告一覧"},
        ]
      },
      {
        breadId: 6,
        description: "広告作成(広告グループ一覧経由)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {
            index: 4,
            path: adgroups_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[4],
            title: adgroup.name
          }, // 選択中の広告グループ名を表示
          {
            index: 5,
            path: advertisements_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[4],
            title: "広告一覧"
          },
          {index: 6, path: currentPath, title: "広告作成"},
        ]
      },
      {
        breadId: 7,
        description: "広告一覧(キャンペーン一覧・作成→広告グループ一覧・作成から遷移)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 4, path: isummary_path + queries[4], title: campaign.name}, // 選択中のキャンペーン名を表示
          {
            index: 5,
            path: adgroups_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[5],
            title: adgroup.name
          }, // 選択中の広告グループ名を表示
          {index: 6, path: currentPath, title: "広告一覧"},
        ]
      },
      {
        breadId: 8,
        description: "広告作成(キャンペーン一覧・作成→広告グループ一覧・作成経由)",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 3, path: isummary_path + queries[4], title: campaign.name}, // 選択中のキャンペーン名を表示
          {
            index: 4,
            path: adgroups_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[5],
            title: adgroup.name
          }, // 選択中の広告グループ名を表示
          {
            index: 5,
            path: advertisements_path + menu.path + "/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[5],
            title: "広告一覧"
          },
          {index: 6, path: currentPath, title: "広告作成"},
        ]
      },
    ]
  };

  
  // NOTE: 現状、categoryId は「id検索」ではなく配列インデックスとして参照されているため、
  //       削除や順序変更すると以降の画面でパンくず構造がずれる可能性がある。
  //       そのため、旧該当画面は削除せず空定義として残す。
  const deletedHome: BreadcrumbsMaster = {
    categoryId: 1,
    description: "ホーム",
    pages: [
    ]
  };

  const deletedCampaigns: BreadcrumbsMaster = {
    categoryId: 12,
    description: "キャンペーン管理",
    pages: [
      {
        breadId: 1,
        description: "キャンペーン一覧",
        list: [
          homePath,
          accountPath,
          {index: 3, path: currentPath, title: "キャンペーン一覧"},
        ]
      },
      {
        breadId: 2,
        description: "キャンペーン作成(静的表示)",
        list: [
          homePath,
          accountPath,
          {index: 3, path: isummary_path + queries[3], title: "キャンペーン一覧"},
          {index: 4, path: currentPath, title: menu.name + "キャンペーン作成"},
        ]
      },
    ]
  };

  const deletedAdgroups: BreadcrumbsMaster = {
    categoryId: 13,
    description: "広告グループ管理",
    pages: [
    ]
  };

    const reviewCsv: BreadcrumbsMaster = {
    categoryId: 27,
    description: "審査結果ダウンロード管理",
    pages: [
      {
        breadId: 1,
        description: "審査結果ダウンロード",
        list: [
          homePath,
          accountPath,
          menuPath,
          {index: 1, path: currentPath, title: "審査結果ダウンロード"},
        ]
      },
      {
        breadId: 2,
        description: "審査結果ダウンロードリクエスト",
        list: [
          homePath,
          accountPath,
          menuPath,
          {
            index: 1, path: review_csv_path + "zeus/" + accountgroup.id + "/" + account.id + "/" + menu.accountId + queries[5],
            title: "審査結果ダウンロード"
          },
          {
            index: 2, path: currentPath, title: "審査結果ダウンロードリクエスト"
          },
        ]
      },
    ]
  };

  const breadcrumbsMaster: BreadcrumbsMaster[] = [
    deletedHome,
    users,
    notifies,
    masters,
    billings,
    budgets,
    logs,
    segments,
    accountgroups,
    accounts,
    platformAccounts,
    deletedCampaigns,
    deletedAdgroups,
    deletedAdvertisements,
    draftCsv,
    assets,
    trackers,
    reports,
    adAssetBatch,
    adClientIcon,
    manuals,
    home,
    campaigns,
    adgroups,
    advertisements,
    tags,
    reviewCsv,
  ];

  let breadcrumbs: Breadcrumb[];
  try {
    breadcrumbs = breadcrumbsMaster[data.categoryId - 1].pages[data.breadId - 1].list;
  } catch (err) {
    return breadcrumbsMaster[0].pages[0].list;
  }
  return breadcrumbs;
}

